"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryParams = exports.getQueryParams = exports.setQueryParams = void 0;

var _react = _interopRequireDefault(require("react"));

var _isNode = _interopRequireDefault(require("./isNode"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var queryParamListeners = [];
var queryParamObject = {};

var setQueryParams = function setQueryParams(inObj) {
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!(inObj instanceof Object)) {
    throw new Error('Object required');
  }

  if (replace) {
    queryParamObject = inObj;
  } else {
    Object.assign(queryParamObject, inObj);
  }

  var now = Date.now();
  queryParamListeners.forEach(function (cb) {
    return cb(now);
  });

  if (!_isNode.default) {
    var qs = '?' + objectToQueryString(queryParamObject);

    if (qs === location.search) {
      return;
    }

    history.replaceState(null, null, location.pathname + (qs !== '?' ? qs : ''));
  }
};

exports.setQueryParams = setQueryParams;

var getQueryParams = function getQueryParams() {
  return Object.assign({}, queryParamObject);
};
/**
 * This takes an URL query string and converts it into a javascript object.
 * @param {string} inStr
 * @return {object}
 */


exports.getQueryParams = getQueryParams;

var queryStringToObject = function queryStringToObject(inStr) {
  var p = new URLSearchParams(inStr);
  var result = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = p[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var param = _step.value;
      result[param[0]] = param[1];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};
/**
 * This takes a javascript object and turns it into a URL query string.
 * @param {object} inObj
 * @return {string}
 */


var objectToQueryString = function objectToQueryString(inObj) {
  var qs = new URLSearchParams();
  Object.entries(inObj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return value !== undefined ? qs.append(key, value) : null;
  });
  return qs.toString();
};

if (!_isNode.default) {
  queryParamObject = queryStringToObject(location.search.substr(1));
}
/**
 * This hook returns the currently set query parameters as object and offers a setter function
 * to set a new query string.
 *
 * All components that are hooked to the query parameters will get updated if they change.
 * Query params can also be updated along with the path, by calling `navigate(url, queryParams)`.
 *
 * @returns {array} [queryParamObject, setQueryParams]
 */


var useQueryParams = function useQueryParams() {
  var setUpdate = _react.default.useState(0)[1];

  _react.default.useEffect(function () {
    queryParamListeners.push(setUpdate);
    return function () {
      var index = queryParamListeners.indexOf(setUpdate);

      if (index === -1) {
        return;
      }

      queryParamListeners.splice(index, 1);
    };
  }, [setUpdate]);

  return [queryParamObject, setQueryParams];
};

exports.useQueryParams = useQueryParams;